import { webKnots } from '../../../../common/back/lace/webKnots'
import { lacePartsOfWeb1, lacePartsOfWeb2, upLeftDownRight, upLeftDownRight2, upRightDownLeft, upRightDownLeft2 } from './parts/laceParts'
import { topSidePartOfWeb } from './parts/sideParts'
import { verticalPartsOfWebCircleEndWithEdge } from './parts/verticalParts'

export const netWeb = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'

  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // 縦パーツ
  verticalPartsOfWebCircleEndWithEdge(ctx, webColor, edgeColor, laceColor, stitchColor)
  upLeftDownRight(ctx, laceColor, 15, -20)
  lacePartsOfWeb1(ctx, laceColor, -3, 2, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -20, 34, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -38, 64, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -23, 92, 1, 0.95)
  lacePartsOfWeb1(ctx, laceColor, -8, 132, 1, 0.9)
  upRightDownLeft(ctx, laceColor, 0, 0)

  upRightDownLeft2(ctx, laceColor, 20, -20)
  lacePartsOfWeb2(ctx, laceColor, -35, -5, -1, 1.05)
  lacePartsOfWeb2(ctx, laceColor, -23, 27, -1, 1)
  lacePartsOfWeb2(ctx, laceColor, -12, 62, -1, 0.95)
  lacePartsOfWeb2(ctx, laceColor, 4, 102, -1, 0.9)
  upLeftDownRight2(ctx, laceColor)

  // laceここから
  webKnots(ctx, laceColor, 25, -60) // ウェブ先端
  webKnots(ctx, laceColor, -105, 115) // 捕球面折り返し上
  ctx.strokeStyle = '#282828'
}
